import {Badge, Loader} from '@mantine/core';
import {useAccountSession} from '../hooks/useAccountSession';
import {AccountSessionBadgeProps} from '../types';

export const AccountSessionBadge = ({account}: AccountSessionBadgeProps) => {
    const {status, isLoading} = useAccountSession(account);

    if (isLoading) {
        return <Loader size="xs" />;
    }

    if (!status.isActive) {
        return <Badge color="gray" size="xs">Not Signed In</Badge>;
    }

    if (status.isExpired) {
        return <Badge color="red" size="xs">Expired</Badge>;
    }

    return <Badge color="green" size="xs">Signed In</Badge>;
};
